import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    projectID: "",
    poaType: "",
    countryOrOthersVariable: "",
    poas: [{
        titleHeader: "",
        folderPathLink: "",
        workbook: {
            id: "",
            name: ""
        },
        worksheet: {
            id: "",
            name: ""
        }
    }],
    recontact: [{
        titleHeader: "",
        folderPathLink: "",
        workbook: {
            id: "",
            name: ""
        },
        worksheet: {
            id: "",
            name: ""
        }
    }],
    isRecontact: false
}


export const sliceName = "MasterFileProjectSlice"


export const MasterFileProjectSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setMasterFileProject: (state, action) => {
            return state = ({ ...action.payload, isRecontact: action.payload.isRecontact })
        },
        setWorkbookIDInSlice: (state, action) => {
            const { index, name, id } = action.payload
            if (state.isRecontact) {
                state.recontact[index].workbook = {
                    id, name
                }
            }
            else {
                state.poas[index].workbook = {
                    id, name
                }
            }
        },
        setWorksheetIDInSlice: (state, action) => {
            const { index, name, id } = action.payload
            if (state.isRecontact) {
                state.recontact[index].worksheet = { id, name }

            }
            else {

                state.poas[index].worksheet = { id, name }
            }
        }
    }
})

export const { setMasterFileProject, setWorkbookIDInSlice, setWorksheetIDInSlice } = MasterFileProjectSlice.actions

export const selectMasterFileProjectDetails = state => state[sliceName]

export default MasterFileProjectSlice.reducer